import {
  DEFAULT_CURRENCY,
  cherrySymbolImg,
  goldNuggetSymbolImg,
  jackpotCrownSymbolImg,
  kunduDrumSymbolImg,
  kumulBirdSymbolImg,
  kinaShellSymbolImg,
  autobetLogoPngImg,
  polCoinSymbolImg,
  diamondSymbolImg,
  btcCoinSymbolImg,
  lucky7SymbolImg,
  jackpotOrbSymbolImg,
  ethCrystalSymbolImg,
  autobetLogoCryptoImg,
} from "../../../../static/Constants";

/**
 * 1 Dropdown with exactly 2 Options: Fiat Pokies vs Crypto Pokies
 */
export const POKIES_TYPE_OPTIONS = [
  {
    id: "fiat",
    label: "Fiat Pokies",
    badge: "Fiat Pokies",
    description:
      "Fiat pokies symbols: Cherry (Mini), Gold Nugget (Major), Royal Crown (Mega Jackpot), Kundu Drum (Free Spins) & Kumul Bird (Super Spins).",
    defaultCurrency: "BET",
  },
  {
    id: "crypto",
    label: "Crypto Pokies",
    badge: "Crypto Pokies",
    description:
      "Crypto pokies symbols: Polygon POL (Mini), Diamond (Major), Bitcoin BTC (Mega Jackpot), Lucky 7 (Free Spins) & Jackpot Orb (Super Spins).",
    defaultCurrency: "BET",
  },
];

/**
 * FIAT Pokies 5-Symbol Set (For 3-SlotBET: Contract Mapped 0 to 4)
 */
export const FIAT_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "cherry",
    label: "Cherry (Mini Jackpot)",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "CHERRY",
    symbolText: "🍒",
    iconText: "🍒",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#10b981",
    color: "#ef4444",
    type: "fiat",
    image: cherrySymbolImg,
    payout: "Mini Jackpot (Min Bet Win)",
    description: "Match 3 Cherries to win Mini Progressive Jackpot & Min Bet payout",
  },
  {
    contractNumber: 1,
    id: "gold_nugget",
    label: "Gold Nugget (Major Jackpot)",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "GOLD",
    symbolText: "🪙",
    iconText: "🪙",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#3b82f6",
    type: "fiat",
    image: goldNuggetSymbolImg,
    payout: "Major Jackpot",
    description: "Match 3 Gold Nuggets to win Major Progressive Jackpot",
  },
  {
    contractNumber: 2,
    id: "jackpot_crown",
    label: "Royal Crown (Mega Jackpot)",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "CROWN",
    symbolText: "👑",
    iconText: "👑",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "fiat",
    image: jackpotCrownSymbolImg,
    payout: "Mega Jackpot",
    description: "Match 3 Crowns to win Grand Mega Progressive Jackpot",
  },
  {
    contractNumber: 3,
    id: "kundu_drum",
    label: "Kundu Drum (5 Free Spins)",
    winningTier: "5 Free Spins",
    winOutcome: "5 Free Spins",
    code: "DRUM",
    symbolText: "🪘",
    iconText: "🪘",
    multiplier: 15,
    tier: "5 Free Spins",
    tierColor: "#8b5cf6",
    color: "#8b5cf6",
    type: "fiat",
    image: kunduDrumSymbolImg,
    payout: "5 Free Spins",
    description: "Match 3 Kundu Drums to trigger 5 Free Spins Bonus Round",
  },
  {
    contractNumber: 4,
    id: "kumul_bird",
    label: "Kumul Bird (10 Super Spins)",
    winningTier: "10 Super Spins",
    winOutcome: "10 Super Spins (2x Win)",
    code: "BIRD",
    symbolText: "🦅",
    iconText: "🦅",
    multiplier: 25,
    tier: "10 Super Spins",
    tierColor: "#dc2626",
    color: "#dc2626",
    type: "fiat",
    image: kumulBirdSymbolImg,
    payout: "10 Super Spins (2x)",
    description: "Match 3 Kumul Birds for 10 Super Free Spins + 2x Win Multiplier",
  },
];

/**
 * CRYPTO Pokies 5-Symbol Set (For 3-SlotBET: Contract Mapped 0 to 4)
 */
export const CRYPTO_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "pol",
    label: "Polygon POL (Mini Jackpot)",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "POL",
    symbolText: "🟣",
    iconText: "🟣",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#10b981",
    color: "#10b981",
    type: "crypto",
    image: polCoinSymbolImg,
    payout: "Mini Jackpot (Min Bet Win)",
    description: "Match 3 POL to win Mini Progressive Jackpot & Min Bet payout",
  },
  {
    contractNumber: 1,
    id: "diamond",
    label: "Diamond (Major Jackpot)",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "DIAMOND",
    symbolText: "💎",
    iconText: "💎",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#3b82f6",
    type: "crypto",
    image: diamondSymbolImg,
    payout: "Major Jackpot",
    description: "Match 3 Diamonds to win Major Progressive Jackpot",
  },
  {
    contractNumber: 2,
    id: "btc",
    label: "Bitcoin BTC (Mega Jackpot)",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "BTC",
    symbolText: "₿",
    iconText: "₿",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "crypto",
    image: btcCoinSymbolImg,
    payout: "Mega Jackpot",
    description: "Match 3 Bitcoins to win Grand Mega Progressive Jackpot",
  },
  {
    contractNumber: 3,
    id: "lucky_7",
    label: "Lucky 7 (5 Free Spins)",
    winningTier: "5 Free Spins",
    winOutcome: "5 Free Spins",
    code: "SEVEN",
    symbolText: "7️⃣",
    iconText: "7️⃣",
    multiplier: 15,
    tier: "5 Free Spins",
    tierColor: "#8b5cf6",
    color: "#8b5cf6",
    type: "crypto",
    image: lucky7SymbolImg,
    payout: "5 Free Spins",
    description: "Match 3 Lucky 7s to trigger 5 Free Spins Web3 Bonus Round",
  },
  {
    contractNumber: 4,
    id: "jackpot_orb",
    label: "Jackpot Orb (10 Super Spins)",
    winningTier: "10 Super Spins",
    winOutcome: "10 Super Spins (2x Win)",
    code: "ORB",
    symbolText: "🔮",
    iconText: "🔮",
    multiplier: 25,
    tier: "10 Super Spins",
    tierColor: "#dc2626",
    color: "#dc2626",
    type: "crypto",
    image: jackpotOrbSymbolImg,
    payout: "10 Super Spins (2x)",
    description: "Match 3 Jackpot Orbs for 10 Super Free Spins + 2x Win Multiplier",
  },
];

/**
 * FIAT Pokies 7-Symbol Set (For 5-SlotBET: Contract Mapped 0 to 6)
 * Keeps 5 symbols from 3-slot (#0-#4) + 2 extra symbols from image5.png (#5 Kina Shell, #6 AutoBET Logo)
 */
export const FIAT_7_SET_SYMBOLS = [
  ...FIAT_SET_SYMBOLS,
  {
    contractNumber: 5,
    id: "kina_shell",
    label: "Kina Shell (High Value)",
    winningTier: "High Value",
    winOutcome: "20x - 50x Win",
    code: "SHELL",
    symbolText: "🐚",
    iconText: "🐚",
    multiplier: 20,
    tier: "High Value",
    tierColor: "#06b6d4",
    color: "#0891b2",
    type: "fiat",
    image: kinaShellSymbolImg,
    payout: "20x Payout",
    description: "Match Kina Shells for traditional PNG currency multipliers!",
  },
  {
    contractNumber: 6,
    id: "autobet_logo",
    label: "AutoBET Logo (Top Symbol)",
    winningTier: "Top Symbol",
    winOutcome: "Top Symbol (35x - 75x)",
    code: "AUTOBET",
    symbolText: "🅰️",
    iconText: "🅰️",
    multiplier: 35,
    tier: "Top Symbol",
    tierColor: "#ec4899",
    color: "#db2777",
    type: "fiat",
    image: autobetLogoPngImg,
    payout: "35x Payout (Top Symbol)",
    description: "AutoBET Logo top payout symbol across all 5 reels!",
  },
];

/**
 * CRYPTO Pokies 7-Symbol Set (For 5-SlotBET: Contract Mapped 0 to 6)
 * Keeps 5 symbols from 3-slot (#0-#4) + 2 extra symbols from image5.png (#5 ETH Crystal, #6 AutoBET Logo)
 */
export const CRYPTO_7_SET_SYMBOLS = [
  ...CRYPTO_SET_SYMBOLS,
  {
    contractNumber: 5,
    id: "eth_crystal",
    label: "ETH Crystal (High Value)",
    winningTier: "High Value",
    winOutcome: "20x - 50x Win",
    code: "ETH",
    symbolText: "💎",
    iconText: "💎",
    multiplier: 20,
    tier: "High Value",
    tierColor: "#06b6d4",
    color: "#0891b2",
    type: "crypto",
    image: ethCrystalSymbolImg,
    payout: "20x Payout",
    description: "Match Ethereum crystals for high-yield Web3 rewards!",
  },
  {
    contractNumber: 6,
    id: "autobet_logo_crypto",
    label: "AutoBET Logo (Top Symbol)",
    winningTier: "Top Symbol",
    winOutcome: "Top Symbol (35x - 75x)",
    code: "AUTOBET",
    symbolText: "🅰️",
    iconText: "🅰️",
    multiplier: 35,
    tier: "Top Symbol",
    tierColor: "#ec4899",
    color: "#db2777",
    type: "crypto",
    image: autobetLogoCryptoImg,
    payout: "35x Payout (Top Symbol)",
    description: "AutoBET Logo top payout symbol across all 5 reels!",
  },
];

/**
 * Helper to get the symbols mapped based on category and symbol count (5 for 3-slot, 7 for 5-slot)
 */
export const getSymbolsByCategory = (category = "fiat", count = 5) => {
  if (count === 7) {
    return category === "crypto" ? CRYPTO_7_SET_SYMBOLS : FIAT_7_SET_SYMBOLS;
  }
  return category === "crypto" ? CRYPTO_SET_SYMBOLS : FIAT_SET_SYMBOLS;
};
